export enum GeograhiesServed {
  northeast = 'NORTHEAST',
  northwest = 'NORTHWEST',
  souteast = 'SOUTHEAST',
  midwest = 'MIDWEST',
  southwest = 'SOUTHWEST',
  north = 'NORTH',
  south = 'SOUTH',
  west = 'WEST',
  east = 'EAST',
  national = 'NATIONAL',
  northAmerica = 'NORTH_AMERICA',
  europe = 'EUROPE',
  asia = 'ASIA',
  africa = 'AFRICA',
  oceania = 'OCEANIA',
  southAmerica = 'SOUTH_AMERICA',
}

export enum GeograhiesServedLabels {
  northeast = 'Northeast',
  northwest = 'Northwest',
  souteast = 'Southeast',
  midwest = 'Midwest',
  southwest = 'Southwest',
  north = 'North',
  south = 'South',
  west = 'West',
  east = 'East',
  national = 'National',
  northAmerica = 'North America',
  europe = 'Europe',
  asia = 'Asia',
  africa = 'Africa',
  oceania = 'Oceania',
  southAmerica = 'South America',
}
